import { type FC } from 'react'
import { Status } from 'shared/ui'
import type { UrlShortener } from 'entities/ShortLink/model/UrlShortener'
import type { IResponseCustomDomain } from 'entities/ShortLink'
import { statusesMap } from 'pages/settings/pages/urlShortener/constants/statusesMap'

type IUrlShortenerStatus = {
  item: UrlShortener | IResponseCustomDomain
}

export const UrlShortenerStatus: FC<IUrlShortenerStatus> = ({ item }) => {
  if (item.status in statusesMap) return <Status {...statusesMap[item.status]} />

  return <Status title={item.status} intent={'negative'} emphasis={'high'} icon={'closeCircle'} />
}
